angular.module('ui.report', [
    'ui.report.reportManager',
    'ui.report.reportRouteContainer',
    'ui.report.reportViewer'
]);